import React, { memo } from 'react';
import PixelSprite from './PixelSprite';
import sprites from '../data/armorSprites.json';

// Ét rustningstrin (16x22 celler).
function ArmorAvatar({ stage, cell = 3 }) {
  return <PixelSprite map={sprites.stages[stage - 1]?.map || []} palette={sprites.palette} cell={cell} />;
}

export default memo(ArmorAvatar);
